<template>
  <!-- desktop product header -->
  <div
    v-if="currentBrand"
    id="fixed_cls"
    class="product-header bg-img"
    :class="{ brandProductHeader: domainBasedBrand }"
  >
    <!-- v-bind:style="{
      'background-image': `url(${brandCoverImage})`,
    }" -->
    <!-- {{ getFilteredOffers }} -->
    <!-- <img
      class="single-image"
      v-if="!customizationLocal.slider_availability"
      alt=""
      :src="applySliderImage"
    /> -->
    <div>
      <offers-single-slider
        :offers="all_brand_website_banners"
        v-if="!getFilteredOffers.length"
      />
      <offers-slider :offers="getFilteredOffers" v-else />
    </div>
    <!-- <offers-slider :offers="getFilteredOffers" /> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
import OffersSlider from '@/components/Blocks/Offers/OffersSlider'
import OffersSingleSlider from '@/components/Blocks/Offers/OffersSingleSlider'

export default {
  mixins: [Windowsize],
  components: {
    OffersSlider,
    OffersSingleSlider,
  },
  data() {
    return {
      fixTop: false,
      brandLogoPath: '',
      brandCoverImage: '',
      searchTerm: '',
    }
  },
  computed: {
    ...mapGetters([
      'currentBrand',
      'currentStore',
      '_T',
      'deliveryTime',
      '_T_DB',
      'find_goorder_kitchen_type_by_main_id',
      'isStoreBrand',
      'siteDomain',
      'getStoreByBrandStoreId',
      'getFilteredOffers',
      'domainBasedBrand',
      'customizationLocal',
      'all_brand_website_banners',
    ]),
    ...mapState({
      selectedKitchenType: state => state.brand_store.selectedKitchenType,
    }),
    // applySliderImage() {
    //   let brandBanner = this.all_brand_website_banners
    //   if (window.matchMedia('(max-width: 500px)').matches) {
    //     if (
    //       brandBanner[0].slider_offer_image_m &&
    //       brandBanner[0].slider_offer_image_m.length
    //     ) {
    //       return brandBanner[0].slider_offer_image_m
    //     } else return brandBanner[0].slider_offer_image
    //   } else return brandBanner[0].slider_offer_image
    // },
    searchItem: {
      get() {
        return this.$store.state.searchItem || this.searchTerm
      },
      set(value) {
        this.searchTerm = value
        this.$store.commit('SET_ITEM_SEARCH_TERM', value)
      },
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    this.$store.commit('SET_ITEM_SEARCH_TERM', '')
  },
  methods: {
    activeSearch() {
      let searchFilter = document.getElementById('search-filter')
      let backBtn = document.getElementById('set-back-button-on-search')
      if (searchFilter.style.display === 'none') {
        searchFilter.style.display = 'block'
        searchFilter.focus()
        searchFilter.style.opacity = '0.9'
        backBtn.style.width = '50px'
      } else {
        backBtn.style.width = '37px'
        searchFilter.style.display = 'none'
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleScroll(event) {
      if (window.scrollY > 250) this.fixTop = true
      else this.fixTop = false
    },
    getImage() {
      if (this.currentBrand && this.currentBrand.company_logo) {
        let url = this.currentBrand.company_logo.split('company_logos/')
        this.brandLogoPath = url[0] + 'company_logos/large/' + url[1]
      }
    },
    getCoverImage() {
      if (this.currentBrand) {
        // if (this.currentBrand[this.siteDomain + '_multi_brand']) {
        //   let store = this.getStoreByBrandStoreId(
        //     this.currentBrand._id,
        //     this.currentStore._id
        //   )
        //   this.$store.commit('IS_STORE_BRAND', store)
        // }
        // if (this.isStoreBrand) {
        //   this.brandCoverImage = this.isStoreBrand[
        //     this.siteDomain + '_brand_cover'
        //   ]
        // }
        if (this.currentBrand.goorder_brand_cover) {
          let url = this.currentBrand.goorder_brand_cover.split(
            'company_logos/'
          )
          this.brandCoverImage = url[0] + 'company_logos/large/' + url[1]
        }
      }
    },
  },
  beforeMount() {
    this.getCoverImage()
    this.getImage()
  },
  beforeDestroy() {
    this.brandLogoPath = ''
    this.brandCoverImage = ''
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .product-header {
    .header-detail {
      .details-right {
        margin-left: unset;
        margin-right: auto;
        .map-section {
          margin-left: unset;
          margin-right: 1.625rem;
        }
      }
    }
    .details-left {
      .top-part {
        .brand-details {
          margin-left: unset;
          margin-right: 1.875rem;
        }
      }
    }
  }
  .bottom-part {
    text-align: right;
    ul {
      padding-left: unset;
      padding-right: 0;
    }
  }
  .brand-section {
    .brand-detail {
      padding-right: 20px;
    }
  }
}
.brandProductHeader {
  padding: $px15 $px15 $px25 !important;
}
.product-header {
  padding: $px35 $px35 $px55;
  position: relative;
  z-index: 1;
  transition: all 0.5s ease;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
  input#search-filter {
    display: none;
  }

  .responsive-detail {
    align-items: flex-start;
    width: 100%;
    text-align: center;
    height: 100%;
    padding-top: $px12;
    padding-bottom: $px12;
    padding-left: $px15;
    padding-right: $px15;
    display: none;
    .back-btn {
      background-color: rgba(var(--color-white-source), 0.3);
      border-radius: 100%;
      width: $px37;
      height: $px37;
      display: flex;
      align-items: center;
      justify-content: center;
      border: $px2 solid $white;
    }
    h4 {
      font-weight: bold;
      font-size: $px18;
      line-height: $px22;
      color: $white;
      text-transform: capitalize;
      margin: 0 auto;
      opacity: 0;
    }
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background-color: rgba($black, 0.2);
    }
  }
  &:after {
    //background: linear-gradient(270deg, #a3080c 0%, rgba(163, 8, 12, 0.82) 100%);
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0.74902) 0%,
      rgba(0, 0, 0, 0.18) 100%
    );
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .header-detail {
    display: flex;
    align-items: flex-start;
    .details-left {
      .top-part {
        display: flex;
        align-items: flex-start;
        .img-part {
          border-radius: $px10;
          border: $px3 solid $white;
          transition: all 0.5s ease;
          background-color: $white;
          display: flex;
          width: $px128;
          height: $px64;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          &.warning-border {
            border-color: $warning-color;
          }
        }
        .brand-details {
          padding-left: $px30;
          h2 {
            font-weight: bold;
            font-size: $px24;
            line-height: $px29;
            letter-spacing: 0.02em;
            color: $white;
            text-transform: capitalize;
          }
          h6 {
            font-weight: normal;
            font-size: $px14;
            line-height: $px22;
            letter-spacing: 0.5px;
            color: $white;
            text-transform: capitalize;
            margin-bottom: -$px4;
            &.kitchen-type {
              padding-left: $px2;
            }
          }
        }
        .bottom-part {
          padding-top: 0;
          transition: all 0.5s ease;
          display: none;
          animation: fadeIn 500ms ease-in-out;
        }
      }
    }
    .details-right {
      margin-left: auto;
      display: flex;
      .address-bar {
        padding-top: $px35;
        p {
          position: relative;
          padding-left: $px30;
          font-size: $px14;
          line-height: $px22;
          letter-spacing: 0.5px;
          color: $white;
          max-width: $px250;
          text-transform: capitalize;
          svg {
            position: absolute;
            left: 0;
            top: $px4;
            width: $px14;
            height: $px14;
          }
        }
      }
      .map-section {
        margin-left: $px26;
        position: relative;
        iframe {
          width: $px170;
          height: $px129;
          border-radius: 4.8px;
          transition: all 0.5s ease;
          animation: fadeIn 500ms ease-in-out;
        }
        .marker-cls {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          svg {
            position: absolute;
            top: $px25;
            right: $px70;
            fill: $primary-color;
            circle {
              fill: $color-secondary;
            }
          }
        }
        .fix-link {
          display: none;
          transition: all 0.5s ease;
          font-style: normal;
          font-weight: 600;
          font-size: $px16;
          line-height: $px19;
          color: $white;
          text-transform: capitalize;
        }
      }
    }
    .header-breadcrumb-option {
      background: $white;
      box-shadow: 0px $px4 $px24 rgba($black, 0.15);
      border-radius: $px4;
      padding: $px9 $px15;
      position: absolute;
      right: $px30;
      bottom: -$px45;
      display: flex;
      align-items: center;
      .btn-dine {
        width: $px230;
        height: $px40;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 0;
        background-color: $warning-color;
        text-transform: capitalize;
        color: $white;
        svg {
          width: $px22;
          height: $px22;
          margin-right: $px16;
        }
      }
      .logo-wrap {
        margin-left: $px30;
        background: $white;
        box-shadow: 0px $px4 $px4 rgba($black, 0.1);
        border-radius: 100%;
        width: $px62;
        height: $px62;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .count {
        h6 {
          font-style: normal;
          font-weight: normal;
          font-size: $px14;
          line-height: $px17;
          color: $black;
          margin-left: $px25;
          margin-bottom: 0;
        }
      }
    }
  }
  .bottom-part {
    padding-top: $px25;
    transition: all 0.5s ease;
    animation: fadeIn 500ms ease-in-out;
    ul {
      li {
        h5 {
          font-style: normal;
          font-weight: 600;
          font-size: $px16;
          line-height: $px19;
          color: $white;
        }
        h6 {
          font-weight: normal;
          font-size: $px12;
          line-height: $px15;
          color: $white;
          text-transform: capitalize;
        }
        + li {
          padding-left: $px32;
        }
      }
    }
  }
  .minimum-order {
    display: flex;
    align-items: center;
    margin-top: $px20;
    margin-left: -$px10;
    .tray-cls {
      width: $px36;
      height: $px36;
      border-radius: 100%;
      border: $px3 solid $white;
      background-color: $warning-color;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }
    span {
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.005em;
      color: $white;
      background-color: $color-tertiary;
      border-radius: $px40;
      padding: $px3 $px10 $px3 $px28;
      margin-left: -$px20;
    }
  }
  &.fixed_top {
    padding: $px25 $px25 $px35;
    position: fixed;
    top: $px84;
    width: 75%;
    flex: 0 0 75%;
    max-width: 75%;
    transition: all 0.5s ease;
    z-index: 2;
    padding-left: $px30;
    .header-detail {
      .details-left {
        .top-part {
          .img-part {
            width: $px55;
            height: $px55;
            transition: all 0.5s ease;
          }
          .fix-none {
            display: none;
          }
          .bottom-part {
            display: block;
            transition: all 0.5s ease;
            animation: fadeIn 500ms ease-in-out;
          }
        }
      }
      .details-right {
        align-items: center;
        .address-bar {
          padding-top: 0;
          p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            margin-bottom: 0;
          }
        }
        .map-section {
          margin-left: $px95;
          iframe {
            display: none;
            transition: all 0.5s ease;
            animation: fadeIn 500ms ease-in-out;
          }
          .marker-cls {
            display: none;
          }
          .fix-link {
            display: block;
            font-style: normal;
            font-weight: 600;
            font-size: $px16;
            line-height: $px19;
            color: $white;
            text-transform: capitalize;
            transition: all 0.5s ease;
          }
        }
      }
    }
    .minimum-order {
      display: none;
    }
    .bottom-part {
      display: none;
      transition: all 0.5s ease;
      animation: fadeIn 500ms ease-in-out;
    }
  }
}
@media (max-width: 1367px) {
  .product-header {
    &.fixed_top {
      .header-detail {
        .details-right {
          .address-bar {
            p {
              max-width: $px210;
            }
          }
          .map-section {
            margin-left: $px25;
          }
        }
      }
    }
    .bottom-part {
      padding-top: $px5;
      ul {
        li {
          h5 {
            margin-bottom: $px3;
          }
          + li {
            padding-left: $px12;
          }
        }
      }
    }
    .header-detail {
      .header-breadcrumb-option {
        padding: $px9 $px15;
        .logo-wrap {
          width: $px52;
          height: $px52;
        }
        .btn-dine {
          width: $px270;
          height: $px45;
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .product-header {
    padding: $px25 $px25 $px45;
    .header-detail {
      .details-left {
        .top-part {
          .img-part {
            width: $px65;
            height: $px65;
          }
          .brand-details {
            padding-left: $px10;
            h2 {
              font-size: $px20;
              margin-bottom: 0;
            }
          }
        }
      }
      .details-right {
        .map-section {
          iframe {
            display: none;
          }
          .marker-cls {
            display: none;
          }
          .fix-link {
            display: block;
          }
        }
        .address-bar {
          padding-top: 0;
        }
      }
      .header-breadcrumb-option {
        bottom: -$px25;
        .logo-wrap {
          width: $px32;
          height: $px32;
          padding: $px5;
          margin-left: $px15;
        }
        .count {
          h6 {
            margin-left: $px10;
          }
        }
        .btn-dine {
          width: $px140;
          height: $px40;
        }
      }
    }
    .minimum-order {
      margin-top: $px10;
      span {
        font-size: $px8;
      }
    }
    .bottom-part {
      ul {
        li {
          h5 {
            font-size: $px14;
          }
          h6 {
            margin-bottom: 0;
          }
        }
      }
    }
    &.fixed_top {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
      .header-detail {
        .details-left {
          .top-part {
            .bottom-part {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .product-header {
    &.fixed_top {
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      .header-detail {
        .details-right {
          .address-bar {
            p {
              max-width: $px310;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .product-header {
    padding: 0;
    height: $px200;
    transition: none;
    .header-detail,
    .bottom-part {
      display: none;
      transition: all 0.5s ease;
    }
    .responsive-detail {
      display: flex;
    }
    .minimum-order {
      position: absolute;
      bottom: $px15;
      left: $px25;
      span {
        font-size: $px14;
      }
    }
    &.fixed_top,
    &.minimal-design {
      top: 0;
      height: $px88;
      transition: none;
      padding: 0;
      .minimum-order {
        display: none !important;
      }
      .responsive-detail {
        align-items: flex-end;
        position: relative;
        z-index: 1;
        h4 {
          opacity: 1;
        }
        &:after {
          background-color: rgba($black, 0.3);
        }
      }
    }
    &:after {
      display: none;
    }
  }
  .mobile-product-header {
    display: block;
  }
}
</style>
